<template>
  <v-row>
    <v-col cols="12" sm="12" md="3">
      <v-text-field
        label="Name"
        :readonly="readonly"
        :disabled="disabled"
        v-model="nameValue"
        :rules="[Required('Name')]"
        outlined
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="10" md="7">
      <EmailInput
        :label="'E-Mail'"
        :email-address="emailAddressValue"
        :is-required="true"
        :readOnly="readonly"
        :disabled="disabled"
        @emailChange="(newValue) => this.emailAddressValue = newValue"
      ></EmailInput>
    </v-col>
    <v-col v-if="showDeleteButton" cols="4" sm="2" md="2" class="pt-0">
      <v-btn
        class="mx-1 my-1"
        color="red"
        outlined
        @click="deleteRecipientHandler({ id })"
      >
        <v-icon color="red">delete</v-icon>
      </v-btn>
    </v-col>
    <ConfirmationModal
      :title="'Delete Confirmation'"
      :contentText="'Are you sure you want to delete the selected recipient?'"
      :toolbarColor="'primary'"
      @cancel-click="() => {
        this.showDeleteConfirmationDialog = false
        this.recipientIdToDelete = null
      }"
      @ok-click="confirmDelete"
      :showModal="showDeleteConfirmationDialog"
    ></ConfirmationModal>
  </v-row>
</template>

<script>
import { EmailInput } from '@/components/emails/index'
import Required from '@/lib/formValidations/required'
import { ConfirmationModal } from '@/components/dialogs'

export default {
  props: [
    'id',
    'name',
    'emailAddress',
    'notes',
    'readonly',
    'recipientsList',
    'disabled',
    'showDeleteButton',
    'showNotes'
  ],
  components: {
    EmailInput,
    ConfirmationModal
  },
  data () {
    return {
      recipientIdToDelete: null,
      showDeleteConfirmationDialog: false
    }
  },
  computed: {
    nameValue: {
      get () {
        return this.name
      },
      set (newValue) {
        this.$emit('nameChange', this.id, newValue)
      }
    },
    emailAddressValue: {
      get () {
        return this.emailAddress
      },
      set (newValue) {
        this.$emit('emailChange', this.id, newValue)
      }
    },
    notesValue: {
      get () {
        return this.notes
      },
      set (newValue) {
        this.$emit('notesChange', this.id, newValue)
      }
    }
  },
  methods: {
    Required,
    deleteRecipientHandler (item) {
      this.recipientIdToDelete = item.id
      this.showDeleteConfirmationDialog = true
    },
    confirmDelete () {
      this.$emit('deleteRecipient', this.recipientIdToDelete)
      this.showDeleteConfirmationDialog = false
      this.recipientIdToDelete = null
    }
  }
}
</script>
